"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.normalizeQueryParams = exports.normalizeFiltersFromGraphQL = exports.isVehicleFilter = exports.hasErrors = exports.hasClearBtn = exports.getUpdatedSelectedFiltersState = exports.getUpdatedSelectedFiltersErrorsState = exports.getTotalSelectedFilters = exports.findSelectedValue = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _offersList = require("../offers-list.config");
var _offersList2 = require("../offers-list.utils");
var _filtersInputLabelKey, _filtersErrorMessages, _filtersOptionValueMa, _filtersOptionNameMap, _filtersOptionLabelKe, _filtersTitle;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var isVehicleFilter = function isVehicleFilter(key) {
  return key === _offersList.filtersMap.VEHICLE;
};
exports.isVehicleFilter = isVehicleFilter;
var filtersInputLabelKeyMap = (_filtersInputLabelKey = {}, _filtersInputLabelKey[_offersList.filtersMap.ZIP_CODE] = 'zipCodeLabel', _filtersInputLabelKey[_offersList.filtersMap.VEHICLE] = 'selectVehiclesLabel', _filtersInputLabelKey[_offersList.filtersMap.OFFER_TYPE] = 'offerTypeFilterLabel', _filtersInputLabelKey[_offersList.filtersMap.MODEL_YEAR] = 'modelYearLabel', _filtersInputLabelKey);
var filtersErrorMessagesKeyMap = (_filtersErrorMessages = {}, _filtersErrorMessages[_offersList.filtersMap.ZIP_CODE] = 'zipCodeErrorMsg', _filtersErrorMessages);
var filtersOptionValueMap = (_filtersOptionValueMa = {}, _filtersOptionValueMa[_offersList.filtersMap.VEHICLE] = 'code', _filtersOptionValueMa[_offersList.filtersMap.OFFER_TYPE] = 'id', _filtersOptionValueMa[_offersList.filtersMap.MODEL_YEAR] = 'id', _filtersOptionValueMa);
var filtersOptionNameMap = (_filtersOptionNameMap = {}, _filtersOptionNameMap[_offersList.filtersMap.VEHICLE] = 'code', _filtersOptionNameMap[_offersList.filtersMap.OFFER_TYPE] = 'label', _filtersOptionNameMap[_offersList.filtersMap.MODEL_YEAR] = 'id', _filtersOptionNameMap);
var filtersOptionLabelKeyMap = (_filtersOptionLabelKe = {}, _filtersOptionLabelKe[_offersList.filtersMap.VEHICLE] = 'vehicleName', _filtersOptionLabelKe[_offersList.filtersMap.OFFER_TYPE] = 'label', _filtersOptionLabelKe[_offersList.filtersMap.MODEL_YEAR] = 'year', _filtersOptionLabelKe);
var filtersTitle = (_filtersTitle = {}, _filtersTitle[_offersList.filtersMap.VEHICLE] = 'allVehiclesLabel', _filtersTitle[_offersList.filtersMap.OFFER_TYPE] = 'allOfferTypeSelectionLabel', _filtersTitle[_offersList.filtersMap.MODEL_YEAR] = 'allModelYearLabel', _filtersTitle);
var getTotalSelectedFilters = function getTotalSelectedFilters(selectedFilters) {
  var totalReducer = function totalReducer(selected, value) {
    if (typeof value === 'string' && value) {
      return [].concat(selected, [true]);
    }
    return [].concat(selected, Object.values(value).filter(Boolean));
  };
  return Object.values(selectedFilters).reduce(totalReducer, []).length || null;
};
exports.getTotalSelectedFilters = getTotalSelectedFilters;
var getFilterMultipleValue = function getFilterMultipleValue(filter, filterKey) {
  var valuesReducer = function valuesReducer(valuesMap, currentFilter) {
    var key = currentFilter[filtersOptionNameMap[filterKey]] || 'id';
    if (key) {
      var _objectSpread2;
      return _objectSpread(_objectSpread({}, valuesMap), {}, (_objectSpread2 = {}, _objectSpread2[key] = false, _objectSpread2));
    }
    return valuesMap;
  };
  return filter.reduce(valuesReducer, {});
};
var getFilterValidationProps = function getFilterValidationProps(filter, filterKey, graphQLConfig) {
  try {
    var regEx = new RegExp(filter.validationRegEx);
    return {
      validate: function validate(value) {
        return regEx.test(value);
      },
      validationRegEx: regEx,
      errorMessage: graphQLConfig[filtersErrorMessagesKeyMap[filterKey]]
    };
  } catch (error) {
    // ignore
  }
  return {};
};
var normalizeQueryParams = function normalizeQueryParams(queryParams) {
  return _offersList.filtersKeys.reduce(function (params, key) {
    var _objectSpread3;
    return _objectSpread(_objectSpread({}, params), {}, (_objectSpread3 = {}, _objectSpread3[key] = queryParams[key], _objectSpread3));
  }, {});
};
exports.normalizeQueryParams = normalizeQueryParams;
var normalizeFiltersFromGraphQL = function normalizeFiltersFromGraphQL(graphQLConfig) {
  var parseFilter = function parseFilter(filter, filterKey) {
    var normalizedFilter = {
      key: filterKey,
      label: graphQLConfig[filtersInputLabelKeyMap[filterKey]] || 'Select',
      errorMessage: null,
      type: Array.isArray(filter) ? _offersList.filtersType.MULTIPLE : _offersList.filtersType.TEXT
    };
    if ((0, _offersList2.isFilterTypeMultiple)(normalizedFilter.type)) {
      normalizedFilter = _objectSpread(_objectSpread({}, normalizedFilter), {}, {
        defaultValue: getFilterMultipleValue(filter, filterKey),
        options: filter.map(function (option) {
          var optionValue = option[filtersOptionValueMap[filterKey]];
          var optionName = option[filtersOptionNameMap[filterKey]];
          return _objectSpread(_objectSpread({}, option), {}, {
            queryValue: Array.isArray(optionValue) ? optionValue.join(',') : optionValue,
            label: option[filtersOptionLabelKeyMap[filterKey]],
            name: optionName,
            value: optionName
          });
        })
      });
    }
    if ((0, _offersList2.isFilterTypeText)(normalizedFilter.type)) {
      normalizedFilter = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, normalizedFilter), filter), getFilterValidationProps(filter, filterKey, graphQLConfig)), {}, {
        defaultValue: ''
      });
    }
    normalizedFilter.getPlaceholder = function (selectedFilters) {
      var labels = normalizedFilter.options.map(function (option) {
        return selectedFilters[normalizedFilter.key][option.name] && option.label;
      }).filter(Boolean);
      if (labels.length === 0 || labels.length === normalizedFilter.options.length) {
        return graphQLConfig[filtersTitle[normalizedFilter.key]] || 'All';
      }
      return labels.join(', ');
    };
    return normalizedFilter;
  };
  var parsedFilters = _offersList.filtersKeys.map(function (filterKey) {
    return parseFilter(graphQLConfig[filterKey], filterKey);
  }).filter(Boolean);
  return parsedFilters;
};
exports.normalizeFiltersFromGraphQL = normalizeFiltersFromGraphQL;
var getUpdatedSelectedFiltersState = function getUpdatedSelectedFiltersState(filter, target, selectedFilters) {
  var _objectSpread5;
  var getValue = function getValue() {
    var _objectSpread4;
    return (0, _offersList2.isFilterTypeMultiple)(filter.type) ? _objectSpread(_objectSpread({}, selectedFilters[filter.key]), {}, (_objectSpread4 = {}, _objectSpread4[target.name] = target.checked, _objectSpread4)) : target.value;
  };
  return _objectSpread(_objectSpread({}, selectedFilters), {}, (_objectSpread5 = {}, _objectSpread5[filter.key] = getValue(), _objectSpread5));
};
exports.getUpdatedSelectedFiltersState = getUpdatedSelectedFiltersState;
var getUpdatedSelectedFiltersErrorsState = function getUpdatedSelectedFiltersErrorsState(filter, value, selectedFiltersErrors) {
  var _objectSpread7;
  if (!(0, _offersList2.isFilterTypeText)(filter.type) || typeof filter.validate !== 'function') {
    return selectedFiltersErrors;
  }

  // Reset error on empty input.
  // This wouldn't work with pristine/dirty states
  if (!value || filter.validate(value)) {
    var _objectSpread6;
    return _objectSpread(_objectSpread({}, selectedFiltersErrors), {}, (_objectSpread6 = {}, _objectSpread6[filter.key] = null, _objectSpread6));
  }
  return _objectSpread(_objectSpread({}, selectedFiltersErrors), {}, (_objectSpread7 = {}, _objectSpread7[filter.key] = filter.errorMessage, _objectSpread7));
};
exports.getUpdatedSelectedFiltersErrorsState = getUpdatedSelectedFiltersErrorsState;
var getSelectedFilterKeysMap = function getSelectedFilterKeysMap(selectedFilter) {
  if (!selectedFilter) {
    return {};
  }
  return Object.entries(selectedFilter).reduce(function (keysMap, _ref) {
    var _objectSpread8;
    var key = _ref[0],
      value = _ref[1];
    return value ? _objectSpread(_objectSpread({}, keysMap), {}, (_objectSpread8 = {}, _objectSpread8[key] = value, _objectSpread8)) : keysMap;
  }, {});
};
var hasClearBtn = function hasClearBtn(selectedFilter) {
  return Object.values(getSelectedFilterKeysMap(selectedFilter)).length > 0;
};
exports.hasClearBtn = hasClearBtn;
var hasErrors = function hasErrors(selectedFiltersErrors) {
  return Object.values(selectedFiltersErrors).filter(Boolean).length > 0;
};
exports.hasErrors = hasErrors;
var findSelectedValue = function findSelectedValue(values) {
  var result;
  Object.keys(values).forEach(function (value) {
    if (values[value] === true) {
      result = value;
    }
  });
  return result;
};
exports.findSelectedValue = findSelectedValue;